import { render, staticRenderFns } from "./UserProfileTwitch.vue?vue&type=template&id=36bbad4c&scoped=true"
import script from "./UserProfileTwitch.vue?vue&type=script&lang=js"
export * from "./UserProfileTwitch.vue?vue&type=script&lang=js"
import style0 from "./UserProfileTwitch.vue?vue&type=style&index=0&id=36bbad4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bbad4c",
  null
  
)

export default component.exports